export class Campaign {
    constructor(campaign) {
        this.id                    = campaign.id;
        this.name                  = campaign.name;
        this.type                  = campaign.type;
        this.created_at            = campaign.created_at;
        this.updated_at            = campaign.updated_at;
        this.is_active             = campaign.is_active;
        this.delivery_time         = campaign.delivery_time;
        this.read_tracking         = campaign.read_tracking;
        this.link_tracking         = campaign.link_tracking;
        this.reply_tracking        = campaign.reply_tracking;
        this.google_analytics      = campaign.google_analytics;
        this.expired_date          = campaign.expired_date;
        this.usable_limit          = campaign.usable_limit;
        this.start_date            = campaign.start_date;
        this.sent_at               = campaign.sent_at;
        this.total_delivered_email = campaign.total_delivered_email;
        this.total_delivered_push  = campaign.total_delivered_push;
        this.total_delivered_sms   = campaign.total_delivered_sms;
        this.total_open            = campaign.total_open;
        this.total_optout          = campaign.total_optout;
        this.total_sent            = campaign.total_sent;
        this.total_visits          = campaign.total_visits;
        this.tracker_id            = campaign.tracker_id;
        this.groups                = campaign.groups;
        this.has_promotion         = campaign.has_promotion;
        this.expired_day_in        = campaign.expired_day_in;
        this.logic_type            = campaign.logic_type;
        this.logic_value           = campaign.logic_value;
    }
}